import { css } from 'linaria';
import { styled } from 'linaria/react';

export const container = css`
  display: flex;
  flex-flow: column wrap;
  align-items: baseline;

  @media (--only-mobile) {
    display: flex;
    flex-direction: column;
    align-items: baseline;
  }
`;

export const mainPriceWrap = css`
  display: inline-block;
  color: var(--text-primary);
`;

export const mainLargePriceWrap = css`
  font-weight: 700;
  font-size: var(--space-275);
  line-height: 29px;

  @media (--only-mobile) {
    font-size: 18px;
    line-height: var(--space-275);
  }
`;

export const smallPriceWrap = css`
  font-weight: 500;
  font-size: var(--space-175);
  line-height: var(--space-250);
`;

export const primaryPriceFractCurrencyWrap = css`
  display: inline-block;
`;

export const primaryLargePriceFractCurrencyWrap = css`
  font-weight: 700;
  font-size: var(--space-150);
  line-height: var(--space-225);

  @media (--from-tablet) {
    font-size: var(--space-175);
    line-height: 23px;
  }
`;

export const newOldPriceStyle = css`
  color: var(--secondary-red-primary);
`;

export const bestPriceStyle = css`
  color: var(--text-primary);
`;

export const padLeft = css`
  padding-left: var(--space-25);
`;

export const padRight = css`
  padding-right: var(--space-50);
`;

export const specialPriceContainer = css`
  display: flex;
  align-items: flex-end;
  margin-right: var(--space-200);

  @media (--only-mobile) {
    width: 100%;
    margin-right: 0;
  }
`;

export const specialOldPriceWrap = css`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

export const oldPriceContainer = css`
  position: relative;
  display: inline-block;

  &::after {
    position: absolute;
    top: 10px;
    left: 0;
    display: block;
    width: 100%;
    height: 2px;
    background: var(--secondary-red-primary);
    content: '';

    @media (--only-mobile) {
      position: relative;
      top: -11px;
    }
  }
`;

export const oldPriceWrap = css`
  color: var(--text-primary);

  @media (--only-mobile) {
    font-size: 12px !important;
  }
`;

export const oldSmallPriceAndCurrencyWrap = css`
  font-size: var(--space-150) !important;
  line-height: var(--space-200) !important;
`;

export const oldCurrencyWrap = css`
  font-weight: 500;
  font-size: 12px !important;
  color: var(--text-primary);
`;

export const priceHintIcon = css`
  display: flex;
  margin: 0;
  border: none;
  padding: var(--space-50);
  width: var(--space-250);
  height: var(--space-250);

  svg {
    width: var(--space-150);
    height: var(--space-150);
  }
`;

export const PlateContainer = styled.div`
  height: var(--space-250);
  margin-bottom: var(--space-75);
  display: inline-flex;
  align-items: center;
  overflow: hidden;

  & > div {
    position: relative;
    z-index: 2;
  }

  & > span {
    margin: 0 var(--space-75) !important;
    font-weight: 700;
    font-size: 9px;
    line-height: 10px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  @media (--only-mobile) {
    order: 0;
  }
`;

export const OPHPlate = css`
  background-color: var(--secondary-red-dark);
  color: var(--secondary-white);
`;

export const bestPricePlate = css`
  background-color: var(--brand-primary);
  color: var(--secondary-black);
`;

export const PlateTile = styled.button`
  background-color: var(--secondary-red-primary);
`;
